import clsx from 'clsx';
import { LitterBinIcon } from 'tt-ui-lib/icons';
import styles from './AboutTag.module.scss';

const AboutTag = ({ tagText, isEditing, deleteItem, index, tags, setTags }) => (
  <div className={styles.tagWrapper}>
    {tagText}
    <div
      className={clsx(styles.deleteIconWrapper, isEditing ? '' : styles.hidden)}
      onClick={() => deleteItem(index, tags, setTags)}
    >
      <LitterBinIcon style={{ width: 15, height: 15 }} />
    </div>
  </div>
);

export default AboutTag;
